<style scoped>
    input{
        height:34px
    }
</style>
<template>
    <input type="text" class="form-control" v-model="quantityController.value" />
</template>
<script>
    //import forminput from "./../../corecontrols/forminput/forminput.scp.html"
    //import { FormElementController , FormElementValidator } from './../../../scripts/formcontrols'
    
    export default {
        model: {
            prop: 'quantityController',
            event: 'input'
        },
        props: ['quantityController'],
        watch: {
            value: function (val) {
                this.$props.value = val;
                this.$emit('input');
            }
        },
        mounted: function () {
            this.value = this.$props.value;
        },
        components: {
           
        }
    }
</script>


// WEBPACK FOOTER //
// drugQuantityEditor.scp.html?17ca20b3